import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ClienteLogin, Menu } from './cliente_login';
import { UsuarioLoginEntity, UsuarioRespuestaEntity } from './usuario_login_entity';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ConstantService } from "../../components/common/utils/constant.service";
import { UsuarioRegistroEntity, ReenviarMailEntity,ClientePersonaEmpresa } from "../register/entities/usuario_registro_entity";
import { PreguntasEntity } from "../register/entities/preguntas_entity";

@Injectable()
export class LoginService {
    authHttp: any;
    private url = "login";

    constructor(private http: Http) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    login(usuarioLogin: UsuarioLoginEntity): Observable<ClienteLogin> {
        let body = JSON.stringify(usuarioLogin);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url + "/validarLogin", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }


    registrarUsuario(usuario: UsuarioRegistroEntity): Observable<boolean> {
        let body = JSON.stringify(usuario);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url + "/registrar", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    reenviarMailActivacion(usuario: ReenviarMailEntity): Observable<ReenviarMailEntity> {
        let body = JSON.stringify(usuario);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url + "/reenviarMailActivacion", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    CambioPassword(usuario: ReenviarMailEntity): Observable<ReenviarMailEntity> {
        let body = JSON.stringify(usuario);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url + "/cambioPassword", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    CambioPasswordDentro(usuario: UsuarioRespuestaEntity){
        let body = JSON.stringify(usuario);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url + "/cambioPasswordDentro", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
   
    verificarCedulaPersona(cedula): Observable<UsuarioRegistroEntity> {
        return this.http.get(this.url + "/esClientePersona/" + cedula).map(this.extractData)
            .catch(this.handleError);
    }

    verificarCedulaEmpresa(cedula): Observable<UsuarioRegistroEntity> {
        return this.http.get(this.url + "/esClienteEmpresa/" + cedula).map(this.extractData)
            .catch(this.handleError);
    }

    verificarUsuario(usuario): Observable<boolean> {
        return this.http.get(this.url + "/validarUsuario/" + usuario).map(this.extractData)
            .catch(this.handleError);
    }

    getPreguntas(): Observable<PreguntasEntity[]> {
        return this.http.get(this.url + "/preguntas").map(this.extractData)
            .catch(this.handleError);
    }

    activarUsuario(codigo, idUser): Observable<number> {
        return this.http.get(this.url + "/activarUsuario/" + codigo + "/" + idUser).map(this.extractData)
            .catch(this.handleError);
    }

    traerPreguntaSecreta(usuario): Observable<string> {
        return this.http.get(this.url + "/traerPreguntaSecreta/" + usuario).map(this.extractData)
            .catch(this.handleError);
    }

    verificarRespuestaSecreta(usuarioRespuesta: UsuarioRespuestaEntity): Observable<boolean> {
        
         let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
         let options = new RequestOptions({ headers: headers });
         let body = JSON.stringify(usuarioRespuesta);
 
         return this.http.post(this.url + "/verificarRespuestaSecreta", body, options).map(this.extractData)
             .catch(this.handleError);
    }

    traerCodigoUsuario(usuario): Observable<UsuarioRespuestaEntity> {
        return this.http.get(this.url + "/traerCodigoUsuario/" + usuario).map(this.extractData)
            .catch(this.handleError);
    }

    actualizarContrasena(usuarioRespuesta: UsuarioRespuestaEntity): Observable<boolean> {
        let body = JSON.stringify(usuarioRespuesta);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url + "/actualizarContrasena", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    consultarMenuXCliente(cliente: number, ciudad: number, tipo: number): Observable<Menu[]> {
        return this.http.get(this.url + "/consultarMenuXCliente/" + cliente + "/" + ciudad + "/" + tipo).map(this.extractData)
            .catch(this.handleError);
    }

    consultaDatosUsuario(cedula,tipo): Observable<ClientePersonaEmpresa> {
        return this.http.get(this.url + "/recuperacionUsuario/" + cedula+ "/" + tipo).map(this.extractData)
            .catch(this.handleError);
    }
    loginMaestra(usuarioLogin: UsuarioLoginEntity): Observable<ClienteLogin> {
        let body = JSON.stringify(usuarioLogin);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url + "/validarLoginMaestra", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    ValidarCambioPass(usuario:ClientePersonaEmpresa): Observable<ClientePersonaEmpresa> {
        let body = JSON.stringify(usuario);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.url + "/ValidaCambioContraseña", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
   
    
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/login.service.ts